import type { ErrorRegistryShape } from '../common/common.error';

export const FILE_ARCHIVE_ERROR = {
  /** 내려받기 티켓이 없거나 만료 · 위조, 또는 그 세션이 끝났다 */
  UNAUTHORIZED_FILE_ARCHIVE_TICKET: { status: 401, message: 'File archive ticket is invalid' },
  /** 묶을 파일이 없다(모두 저장소에 없음 · 범위에 파일 없음) */
  NOT_FOUND_FILE_ARCHIVE_EMPTY: { status: 404, message: 'No files to archive' },
} as const satisfies ErrorRegistryShape;
